var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLev2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 192 356",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fae757;\n      }\n\n      .cls-2 {\n        fill: #4d3423;\n      }\n\n      .cls-3 {\n        fill: #015e59;\n      }\n\n      .cls-4 {\n        fill: #cc8f70;\n      }\n\n      .cls-5 {\n        fill: #414a4c;\n      }\n\n      .cls-6 {\n        opacity: .5;\n      }\n\n      .cls-6, .cls-7 {\n        fill: #fff;\n      }\n\n      .cls-8 {\n        fill: #eeb68c;\n      }\n\n      .cls-9 {\n        fill: #bfa776;\n      }\n\n      .cls-10 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-11 {\n        clip-path: url(#clippath-3);\n      }\n\n      .cls-12 {\n        clip-path: url(#clippath-4);\n      }\n\n      .cls-13 {\n        clip-path: url(#clippath-2);\n      }\n\n      .cls-14 {\n        fill: #e6eef2;\n      }\n\n      .cls-15 {\n        fill: #7bd2e8;\n      }\n\n      .cls-16 {\n        fill: #cfb580;\n      }\n\n      .cls-17 {\n        fill: #eb986d;\n      }\n\n      .cls-18 {\n        fill: url(#Degradado_sin_nombre_3);\n      }\n\n      .cls-19 {\n        fill: #edb58c;\n      }\n\n      .cls-20 {\n        fill: #a69166;\n      }\n\n      .cls-21 {\n        fill: #073f4a;\n      }\n\n      .cls-22 {\n        fill: #6fe8dd;\n      }\n\n      .cls-23 {\n        fill: none;\n        stroke: #4eadad;\n        stroke-miterlimit: 10;\n        stroke-width: 2px;\n      }\n\n      .cls-24 {\n        fill: #65442e;\n      }\n\n      .cls-25 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-26 {\n        fill: #002131;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M76.31,46.66h34.51c10.79,0,19.55,8.76,19.55,19.55v48.71c0,16.83-13.67,30.5-30.5,30.5h-12.62c-16.83,0-30.5-13.67-30.5-30.5v-48.71c0-10.79,8.76-19.55,19.55-19.55Z",
    transform: "translate(15.52 -12.99) rotate(8.66)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 111.35,
    y: 84.43,
    width: 19.55,
    height: 27.38,
    rx: 9.77,
    ry: 9.77,
    transform: "translate(16.15 -17.11) rotate(8.66)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 78.78,
    y: 79.47,
    width: 19.55,
    height: 27.38,
    rx: 9.77,
    ry: 9.77,
    transform: "translate(15.03 -12.27) rotate(8.66)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M184.16,131.97l-.61-.61c-.54-.54-1.4-.54-1.94,0l-1.75,1.75-35.73,35.73c-.53.53-.93,1.16-1.18,1.86l-6.75,19.06c-.18.5-.05,1.05.32,1.43l.61.61c.54.54,1.4.54,1.94,0l2.07-2.07,35.61-35.61c.39-.39.68-.86.87-1.37l6.85-19.33c.18-.5.05-1.05-.32-1.43Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "138.96 187.52 146.38 166.59 179.7 133.27 172.28 154.2 138.96 187.52"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_3",
    "data-name": "Degradado sin nombre 3",
    x1: 83.12,
    y1: 88.4,
    x2: 236.98,
    y2: 226.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#fff",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#fff",
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#fff",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Calque_3"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 87.5,
    cy: 315,
    rx: 65.5,
    ry: 27
  })), /*#__PURE__*/React.createElement("g", {
    id: "Calque_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 157.54,
    cy: 164.71,
    r: 15.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 140.02,
    y: 162.75,
    width: 16.81,
    height: 18.24,
    transform: "translate(320.29 23.45) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 86.09,
    y: 134.44,
    width: 25.17,
    height: 54.27,
    rx: 12.58,
    ry: 12.58,
    transform: "translate(282.69 206.06) rotate(135)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M110.79,149.31h16.33c2.44,0,4.42,1.98,4.42,4.42v28.11c0,6.95-5.64,12.58-12.58,12.58h0c-6.95,0-12.58-5.64-12.58-12.58v-28.11c0-2.44,1.98-4.42,4.42-4.42Z",
    transform: "translate(290.83 52.91) rotate(90)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 76.76,
    y: 195.97,
    width: 27.06,
    height: 70.77,
    rx: 13.53,
    ry: 13.53
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M84.19,239.64h11.66c4.41,0,7.98,3.58,7.98,7.98v39.57c0,7.47-6.06,13.53-13.53,13.53h0c-7.47,0-13.53-6.06-13.53-13.53v-40.13c0-4.1,3.33-7.42,7.42-7.42Z",
    transform: "translate(180.59 540.36) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M76.76,289.8h23.41c4.15,0,7.51,3.37,7.51,7.51v4.66c0,2.21-1.79,4.01-4.01,4.01h-22.92c-2.21,0-4.01-1.79-4.01-4.01v-12.17h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M80.68,300.72h30.27c5.36,0,9.71,4.35,9.71,9.71h0c0,2.08-1.69,3.77-3.77,3.77h-36.2c-2.16,0-3.92-1.76-3.92-3.92v-5.64c0-2.16,1.76-3.92,3.92-3.92Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 53.37,
    y: 209.35,
    width: 27.06,
    height: 70.77,
    rx: 13.53,
    ry: 13.53
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M60.79,253.02h11.66c4.41,0,7.98,3.58,7.98,7.98v39.57c0,7.47-6.06,13.53-13.53,13.53h0c-7.47,0-13.53-6.06-13.53-13.53v-40.13c0-4.1,3.33-7.42,7.42-7.42Z",
    transform: "translate(133.79 567.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M53.37,303.17h23.65c4.02,0,7.28,3.26,7.28,7.28v4.9c0,2.21-1.79,4.01-4.01,4.01h-22.92c-2.21,0-4.01-1.79-4.01-4.01v-12.17h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M57.29,314.1h30.27c5.36,0,9.71,4.35,9.71,9.71h0c0,2.08-1.69,3.77-3.77,3.77h-36.2c-2.16,0-3.92-1.76-3.92-3.92v-5.64c0-2.16,1.76-3.92,3.92-3.92Z"
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-23",
    x1: 80.43,
    y1: 218.44,
    x2: 80.43,
    y2: 303.17
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M57.29,143.57h41.72c10.03,0,18.17,8.14,18.17,18.17v60.7H39.12v-60.7c0-10.03,8.14-18.17,18.17-18.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M97.04,143.62c0,6.55-5.31,11.86-11.86,11.86h-7.03s-7.03,0-7.03,0c-6.55,0-11.86-5.31-11.86-11.86h0s37.77,0,37.77,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M112.38,98.96l-51.36-9.2c-6.41-.98-10.85-7.01-9.87-13.42l4.23-27.8c1.54-10.12,11.09-17.15,21.21-15.61l37.83,7.14c10.12,1.54,17.15,11.09,15.61,21.21l-4.23,27.8c-.98,6.41-7.01,10.85-13.42,9.87Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 62.94,
    y: 125.75,
    width: 30.41,
    height: 20.91
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M76.31,46.66h34.51c10.79,0,19.55,8.76,19.55,19.55v48.71c0,16.83-13.67,30.5-30.5,30.5h-12.62c-16.83,0-30.5-13.67-30.5-30.5v-48.71c0-10.79,8.76-19.55,19.55-19.55Z",
    transform: "translate(15.52 -12.99) rotate(8.66)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M136.14,128.39l-9.09-1.38c-5.28-.8-10.22,2.83-11.02,8.11l-1.7,11.19c-.8,5.26-5.72,8.88-10.98,8.08l-18.89-2.88c-5.26-.8-8.88-5.72-8.08-10.98l1.7-11.19c.8-5.28-2.83-10.22-8.11-11.02l-18.84-2.87-4.91,32.26,26.87,4.22-.91,6.01,40.92,6.23.91-6.01,17.21,2.62,4.93-32.38Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M117.65,130.05c-3.84,5.62-10.67,8.86-17.86,7.77-7.17-1.09-12.74-6.22-14.73-12.73l32.58,4.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M98.05,125.54l-15.73-1.81c-1.48-.18-1.46-2.35.02-2.5,0,0,15.76-1.58,15.76-1.58,4.33-.23,4.29,6.19-.04,5.89h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M108.39,121.21l14.57,6.2c1.37.59.73,2.67-.73,2.4,0,0-15.56-2.96-15.56-2.96-4.22-1-2.36-7.15,1.71-5.64h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 111.35,
    y: 84.43,
    width: 19.55,
    height: 27.38,
    rx: 9.77,
    ry: 9.77,
    transform: "translate(16.15 -17.11) rotate(8.66)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 117.33,
    y: 94.14,
    width: 11.17,
    height: 18.74,
    rx: 5.58,
    ry: 5.58,
    transform: "translate(16.98 -17.32) rotate(8.66)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 117.53,
    y: 90.75,
    width: 6.11,
    height: 11.14,
    rx: 3.05,
    ry: 3.05,
    transform: "translate(15.87 -17.05) rotate(8.66)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M111.32,88.67c-.37-1.46-2.3-1.75-3.09-.47-3.07,5.02-9.05,17.87-10.23,25.63-1.01,6.62,6.65,8.27,6.65,8.27,0,0,7.81.7,8.81-5.92,1.18-7.76-.7-21.8-2.14-27.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M125.85,107.52h3.36v6.88c0,3.58-2.91,6.49-6.49,6.49h0c-.72,0-1.31-.59-1.31-1.31v-7.62c0-2.45,1.99-4.44,4.44-4.44Z",
    transform: "translate(231.99 245.97) rotate(-171.34)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 57.54,
    cy: 91.59,
    r: 11.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 49.5,
    y: 96.69,
    width: 3.96,
    height: 8.78,
    rx: 1.98,
    ry: 1.98,
    transform: "translate(15.8 -6.6) rotate(8.66)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M68.62,48.64h8.31v38.4c0,4.96-4.02,8.98-8.98,8.98h0c-4.96,0-8.98-4.02-8.98-8.98v-28.75c0-5.33,4.32-9.65,9.65-9.65Z",
    transform: "translate(11.66 -9.4) rotate(8.66)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 78.78,
    y: 79.47,
    width: 19.55,
    height: 27.38,
    rx: 9.77,
    ry: 9.77,
    transform: "translate(15.03 -12.27) rotate(8.66)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 84.76,
    y: 89.18,
    width: 11.17,
    height: 18.74,
    rx: 5.58,
    ry: 5.58,
    transform: "translate(15.86 -12.48) rotate(8.66)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 84.96,
    y: 85.79,
    width: 6.11,
    height: 11.14,
    rx: 3.05,
    ry: 3.05,
    transform: "translate(14.75 -12.21) rotate(8.66)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M144.82,47.09c.84-5.54-1.7-10.8-6.08-13.71-.56-6.25-5.3-11.55-11.78-12.54-.24-.04-.47-.05-.71-.07-1.13-3.28-3.99-5.85-7.66-6.41-1.33-.2-2.64-.12-3.87.2-2.66-2.2-5.93-3.75-9.59-4.31-4.4-.67-8.68.19-12.32,2.15-1.41-1.44-3.28-2.46-5.42-2.78-4.14-.63-8.06,1.47-9.94,4.96-1.16-.55-2.42-.95-3.76-1.15-6.98-1.06-13.51,3.43-15.14,10.16-4.53,1.3-8.14,5.12-8.89,10.09-.62,4.06.81,7.94,3.49,10.64-.71,1.01-1.21,2.19-1.41,3.5-.69,4.51,2.41,8.72,6.92,9.41,3.55.54,6.9-1.27,8.51-4.25,2.24,2.47,5.31,4.22,8.87,4.76,4.13.63,8.12-.48,11.23-2.79,2.03,4.31,6.1,7.57,11.16,8.34s9.78-1.07,13-4.49c2,2.64,4.85,4.63,8.24,5.5,1.25,1.56,3.06,2.69,5.2,3.01,4.51.69,8.72-2.41,9.41-6.92.01-.09.02-.17.03-.26.61-.64,1.16-1.34,1.66-2.08,4.55-1.73,8.07-5.78,8.86-10.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M74.01,100.52h0c6.27,0,11.36,5.09,11.36,11.36v2.01h-9.94c-3.18,0-5.77-2.58-5.77-5.77v-3.26c0-2.4,1.95-4.34,4.34-4.34Z",
    transform: "translate(17.02 -10.45) rotate(8.66)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-24",
    cx: 109.38,
    cy: 63.87,
    r: 14.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-24",
    cx: 112.22,
    cy: 45.21,
    r: 19.76
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-24",
    cx: 89.14,
    cy: 58.38,
    r: 15.06
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-24",
    cx: 78.75,
    cy: 51.99,
    r: 12.45
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-24",
    cx: 138.6,
    cy: 61.1,
    r: 12.45
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-24",
    cx: 89.43,
    cy: 43.36,
    r: 13.49
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-24",
    cx: 125.34,
    cy: 63.89,
    r: 15.06
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-24",
    cx: 129.25,
    cy: 49.42,
    r: 13.49
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-24",
    cx: 100.88,
    cy: 35.33,
    r: 9.66
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-24",
    cx: 121.61,
    cy: 38.49,
    r: 9.66
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-24",
    cx: 137.64,
    cy: 74.78,
    r: 8.26
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-24",
    cx: 74.48,
    cy: 65.16,
    r: 8.26
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M184.16,131.97l-.61-.61c-.54-.54-1.4-.54-1.94,0l-1.75,1.75-35.73,35.73c-.53.53-.93,1.16-1.18,1.86l-6.75,19.06c-.18.5-.05,1.05.32,1.43l.61.61c.54.54,1.4.54,1.94,0l2.07-2.07,35.61-35.61c.39-.39.68-.86.87-1.37l6.85-19.33c.18-.5.05-1.05-.32-1.43Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M136.54,188.81l6.8-19.18,39.24-39.24-6.99,19.72c-.28.8-.74,1.52-1.34,2.12l-37.01,37.01c-.32.32-.85-.02-.7-.44Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "138.96 187.52 146.38 166.59 179.7 133.27 172.28 154.2 138.96 187.52"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "149.62 178.44 142.21 185.87 165.5 145.18 172.91 137.76 149.62 178.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "156.56 172.38 152.75 176.21 176.03 135.52 179.85 131.7 156.56 172.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "142.88 176.84 140.73 178.99 153.86 156.07 156.01 153.91 142.88 176.84"
  }))))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "164.55 93.16 179.86 133.1 172.28 154.2 141.05 185.43 97.25 169.45 164.55 93.16"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 135.6,
    cy: 188.58,
    r: 15.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 118.07,
    y: 186.62,
    width: 16.81,
    height: 18.24,
    transform: "translate(-69.27 322.22) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 63.86,
    y: 158.3,
    width: 25.17,
    height: 54.27,
    rx: 12.58,
    ry: 12.58,
    transform: "translate(-108.73 108.37) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M97.01,173.19h0c6.95,0,12.58,5.64,12.58,12.58v28.11c0,2.44-1.98,4.42-4.42,4.42h-16.33c-2.44,0-4.42-1.98-4.42-4.42v-28.11c0-6.95,5.64-12.58,12.58-12.58Z",
    transform: "translate(-98.74 292.75) rotate(-90)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLev2);
export default __webpack_public_path__ + "static/media/lev_2.5a4d33b6559a8712f84655da007e6c33.svg";
export { ForwardRef as ReactComponent };